import { render, staticRenderFns } from "./uEditorTool.vue?vue&type=template&id=04e755a5&scoped=true"
import script from "./uEditorTool.vue?vue&type=script&lang=js"
export * from "./uEditorTool.vue?vue&type=script&lang=js"
import style0 from "./uEditorTool.vue?vue&type=style&index=0&id=04e755a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e755a5",
  null
  
)

export default component.exports